import http from '@/http'
const URL = '/admin/email-suppressions'

export const listSuppressions = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const saveSuppression = (payload) => http.post(URL, payload)

export const deleteSuppression = async (id) => http.delete(URL + `/${id}`)

export const checkSuppressions = async (emails) => http.post(URL + '/check', { emails })

export default {
  listSuppressions,
  saveSuppression,
  deleteSuppression,
  checkSuppressions
}
